import '../../App.css';
import { useNavigate } from 'react-router-dom';
import assetsManagerImg from '../../assets/images/assetsManager.png';
import { useAccount, useProvider, useSigner } from 'wagmi';
import { ProgressBar } from 'primereact/progressbar';
import { ethers } from 'ethers';
import { useEffect, useRef, useState } from 'react';
import RiveraAutoCompoundingVaultV2WhitelistedJson from '../../abi/out/RiveraAutoCompoundingVaultV2Whitelisted.sol/RiveraAutoCompoundingVaultV2Whitelisted.json'
import StablePairColorImg from '../../assets/images/StablePairColor.svg';
import VolatilePairColorImg from '../../assets/images/volatilePair.png';
import revenueEarningImg from '../../assets/images/revenueEarning.svg';
import uptrendMarketImg from '../../assets/images/uptrendMarket.svg';
import almImg from '../../assets/images/alm.svg';
import LSDFarmingImg from '../../assets/images/LSDFarming.svg';
import dynamicStrategyImg from '../../assets/images/dynamicStrategy.png';
import Decimal from 'decimal.js';
import { Tooltip } from 'primereact/tooltip';
import infoCircleImg from '../../assets/images/info_circle.svg';
import boosted from '../../assets/images/Boosted 2.svg';
import { backendApiUrlBase } from '../../constants/global';
import quantBull from '../../assets/images/quantBull.png'

function Quant() {

  const viewDetailsbuttonVal = "View Details --->"
  const managebuttonVal = "Manage --->";
  const [isAdmin, setIsAdmin] = useState(false);
  const [isDataLoadng, setIsDataLoadng] = useState(false);
  const [isWhiteListed, setWhiteListed] = useState(true);
  const [totalTvl, setTotalTvl] = useState("");
  const [totalVault, setTotalVault] = useState(0);
  const [portfolio, setPortfolio] = useState("");
  const [valutList, setvalutList] = useState<any>([]);
  const [lamaTotalTvl, setLamaTotalTvl] = useState("");
  const { address, isConnected } = useAccount();
  const provider = useProvider();
  const { data: signer, isError, isLoading } = useSigner();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);

  useEffect(() => {
    getDeployedValut();
  }, [address, isLoading]);



  const getTwoDecimal = (num: any) => {
    const roundedNum = Math.floor(num * 100) / 100;
    return roundedNum;
  }

  const getActualvalue = (num: any, decimal: any) => {
    const roundedNum = Number(new Decimal(num.toString()).div(new Decimal(Math.pow(10, Number(decimal)))));
    return roundedNum;
  }

  const getContract = (address: string, abi: any, provider: any) => {
    return new ethers.Contract(address, abi, provider);
  }

  async function getDeployedValut() {
    setIsDataLoadng(true);

    const vaultData = await fetch(`${backendApiUrlBase}vaults/?quant=true`);

    let vaultJsonData = await vaultData.json();

    const aprData = await fetch(`${backendApiUrlBase}xRIV/vaults`);
    let aprDataJsonData = await aprData.json();

    let tvlUsd = 0;
    let totalPortfolio = 0;

    //filter for quant valut and dashboard page visiable condition 
    // const vaultJsonDataFilterVal = await Promise.all(vaultJsonData.filter((e: any) => e.dashboard && e.quant).map(async (valutDetailsInJson: any) => {
    const vaultJsonDataFilterVal = await Promise.all(vaultJsonData.filter((e: any) => e.quant).map(async (valutDetailsInJson: any) => {

      const tvl = getActualvalue(valutDetailsInJson.totalAssets, valutDetailsInJson.denominationDecimal);
      const tvlCap = getActualvalue(valutDetailsInJson.totalTvlCap, valutDetailsInJson.denominationDecimal);
      const sysmbolArray = valutDetailsInJson?.symbol.split('-');
      const vaultType = sysmbolArray[sysmbolArray.length - 1];

      //tvlUsd = tvlUsd + valutDetailsInJson?.tvlUSD;
      const assetArray = valutDetailsInJson?.displayName.split('-');
      const asset1 = assetArray[0].toLowerCase();
      const asset2 = assetArray[1].toLowerCase();
      const returnVal = {
        "tickLowerPrice": valutDetailsInJson.tickLower,
        "tickUpperPrice": valutDetailsInJson.tickUpper,
        "currentAllocation": null,
        "lastHarvestdate": null,
        "feeTier": valutDetailsInJson?.poolFee, //need to discuss
        "financeType": valutDetailsInJson?.dex,
        "financeTypeVal": valutDetailsInJson?.dex, //need to discuss
        "strategyTypeVal": vaultType, //need to discuss
        "strategyType": valutDetailsInJson?.strategyType, //need to discuss
        "name": valutDetailsInJson?.displayName,
        "assetImg": `../image/assets/${asset1}.png`, //need to discuss
        "assetImg2": `../image/assets/${asset2}.png`, //need to discuss
        "assetName": valutDetailsInJson?.denominationAsset, //need to discuss
        "chainImg": `../image/chain/${valutDetailsInJson?.chain}.png`, //need to discuss
        "saftyRating": null, //need to discuss
        "tvlInUsd": valutDetailsInJson?.tvlUSD,
        "tvl": tvl, //need to discuss
        "averageApy": aprDataJsonData.find((e: any) => e.identifier === valutDetailsInJson.identifier)?.apr * 100, //need to discuss
        "averageLPAPR": aprDataJsonData.find((e: any) => e.identifier === valutDetailsInJson.identifier)?.lpAPR * 100, //need to discuss
        "valutAddress": valutDetailsInJson?.vaultAddress,
        "identifier": valutDetailsInJson?.identifier,
        "tvlcapInUsd": tvlCap, //need to discuss
        "tvlcap": getActualvalue(valutDetailsInJson?.totalTvlCap, valutDetailsInJson.denominationDecimal), //need to discuss
        "valutApy": null, //need to discuss
        "percentage": null, //((tvlInUsd / tvlcapInUsd) * 100).toFixed(4)
        "totalPortfolio": null,
        "totalOverallreturnVal": null,

        "totalAverageApy": null,
        "poweredBy": `../image/dex/${valutDetailsInJson?.dex}.png`,
        "isStablePair": true,
        "isLSDFarming": true,
        "isVolatilePair": false,
        "isLiquidityMining": false,
        "isDynamicStrategy": false,
        "isActiveStrategy": false,
        "isPeggedStrategy": false,
        "isStaticRange": false,
        "isWideRange": false,
        "currentPrice": 0,
        "vaultShare": 0,
        "tags": valutDetailsInJson?.tags
      };

      return returnVal;
    }));
    setvalutList(vaultJsonDataFilterVal);
    setTotalVault(vaultJsonDataFilterVal.length);

    const priceData = await fetch("https://api.rivera.money/oracle/coingecko");
    let priceJsonData = await priceData.json();

    await Promise.all(vaultJsonData.filter((e: any) => e.quant).map(async (valutDetailsInJson: any) => {
      const tvl = getActualvalue(valutDetailsInJson.totalAssets, valutDetailsInJson.denominationDecimal);
      const tSupply = getActualvalue(valutDetailsInJson.totalSupply, valutDetailsInJson.denominationDecimal);
      if (address) {
        const convertedPrice = priceJsonData.find((e: any) => (e.denominationAssetAddress.toLowerCase() === valutDetailsInJson.denominationAssetAddress.toLowerCase()))?.priceUSD;
        if (convertedPrice) {
          const localProvider = new ethers.providers.JsonRpcProvider(valutDetailsInJson.chainRPC);
          const vaultContract = getContract(valutDetailsInJson.vaultAddress, RiveraAutoCompoundingVaultV2WhitelistedJson.abi, localProvider);
          let share = await vaultContract.balanceOf(address);
          share = getActualvalue(share, valutDetailsInJson.denominationDecimal);
          const userShareVal = (tvl * share) / tSupply;
          const userShareInUsd = userShareVal * convertedPrice;
          totalPortfolio = totalPortfolio + userShareInUsd;
        }

      }
      tvlUsd = tvlUsd + valutDetailsInJson?.tvlUSD;
      console.log("tvlUsd", tvlUsd);
    }));

    setTotalTvl(tvlUsd.toString());
    setPortfolio(totalPortfolio.toFixed(2));
    setIsDataLoadng(false);
  }


  const gotoDiscord = () => {
    const url = 'https://discord.com/invite/DkdZ5DyJga';
    window.open(url, '_blank');
  }

  const fnum = (x: any) => {
    if (isNaN(x)) return x;

    if (x < 999) {
      return getTwoDecimal(x);
    }

    if (x < 1000) {
      return getTwoDecimal(x);
    }

    if (x < 10000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 100000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 1000000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 10000000) {
      return getTwoDecimal(x / 1000000) + "M";
    }

    if (x < 1000000000) {
      return getTwoDecimal(x / 1000000) + "M";
    }

    if (x < 1000000000000) {
      return getTwoDecimal(x / 1000000000) + "B";
    }

    return "1T+";
  }

  const getTagIcon = (tag: string): string => {
    switch (tag) {
      case 'Uptrend Market':
        return uptrendMarketImg;
      case 'Revenue Earning':
        return revenueEarningImg;
      case 'Liquidity Mining':
        return almImg;
      case 'Active Strategy':
        return almImg;
      case 'Wide Range':
        return almImg;
      case 'Pegged Strategy':
        return dynamicStrategyImg;
      case 'Static Range':
        return dynamicStrategyImg;
      case 'Dynamic':
        return dynamicStrategyImg;
      case 'LSD Farming':
        return LSDFarmingImg;
      case 'Volatile Pair':
        return VolatilePairColorImg;
      case 'Stable Pair':
        return StablePairColorImg;
      case 'Boosted':
        return boosted;

      default:
        return almImg;
    }
  };

  
  return (
    <>
      {loading ? <><div className="loader-container">
        <div className="spinner"></div>
      </div></> : <>
        <div className="custom-container">
          <div className='flexdown mb-3 mt--1'>
            <h1 className='first_sec_heder3 redHatFont ml-1 mt-05'> Featured vaults</h1>
            {/* <div className='filters'>
                <Dropdown
                  className=' '
                  style={{ borderRadius: '0' }}
                  value={selectedFilter}
                  options={filterOptionsStra}
                  onChange={handleFilterChange}
                  placeholder="Select Strategy"
                  panelStyle={{ borderRadius: '0' }}
                />
                <Dropdown
                  className=' mb_5 dropDown'
                  value={selectedFilter}
                  options={filterOptionsDEX}
                  onChange={handleFilterChangeDEX}
                  placeholder="Select Chain"
                  panelStyle={{ borderRadius: '0' }}
                />
              </div> */}
          </div>
          <div className='second_section row mt-5 mb-5'>
            {/* <h4 className='valut_header redHatFont fnt_wgt_600'>Quant Strategy Vaults</h4> */}

            {valutList.map((e: any, index: any) => {
              return <div className='card_wdth_50' key={index}>

                <div className='first_section outer_section'>
                  <div className={`bckgrnd_img_card_fnt bckgrnd_img_quant_card_stable`}>
                    <div className='dsp_start qunatCardPadding'>
                      <div className='d-flex align-items-start'>
                        <div className='d-flex'><img src={e.assetImg} alt='btc img' className='btc_asst_img_width' /><img src={e.assetImg2} alt='btc img' className='btc_img_width' /></div>
                        <div>
                          <div className='vault_header_font_size'>{e.name}</div>
                          <div className='card_snd_clr fnt_14 notMobileDevice'>{e?.financeType}</div>
                        </div>

                      </div>
                      <div className='notMobileDevice'>
                        <span className='card_snd_clr'>Fee Tier</span>
                        <br />
                        <span className=''>{(e.feeTier / Math.pow(10, 4)).toFixed(2)}%</span>
                      </div>
                      {/* <div><span className='holding_val ml_8'>{e.saftyRating}</span>
                        {e.saftyRating ? <img src={saftyImg} alt='lock img' className='wthlist_back_img' /> : <></>}
                      </div> */}
                      <div className='chain_pos_det'>
                        <span><img src={e.chainImg} alt='chain' /></span>
                      </div>
                    </div>
                    <div className='mobileDevice mt-2 ml-1 '>
                      <div className='dsp_start'>
                        <div>
                          <span className='card_snd_clr'>Fee Tier</span>
                          <br />
                          <span>{(e.feeTier / Math.pow(10, 4)).toFixed(2)}%</span>
                        </div>
                        <div>
                          <img src={quantBull} alt='lock img' className='cashaa logo' />
                        </div>

                      </div>
                    </div>

                    <div className='pos_dp quantBullPadding'>
                      <div>
                        <div className='vault_sub_header_font_size card_snd_clr'>{e.strategyType}</div>
                        <div className='d-flex dspWrap mt-2 mb-4'>
                          {isAdmin ?
                            <>
                              <div className='mr_20'>
                                % utilisation
                                <br />
                                <span className='fnt_wgt_600'>0%</span>
                              </div>

                              <div>
                                Share Price
                                <br />
                                <span className='fnt_wgt_600'>{e?.vaultShare?.toFixed(2)} {e.assetName}</span>
                              </div>
                            </> : <>
                              {e?.tags.map((tag: string, index: number) => (
                                <div className='trdng_outer mr_12' key={index}>
                                  <span className='trdng_width'>
                                    <img src={getTagIcon(tag)} className='ml_8' alt={`${tag} img`} />
                                    {tag}
                                  </span>
                                </div>
                              ))}

                            </>
                          }
                        </div>
                      </div>
                      <div className='mb-1 notMobileDevice'><img src={quantBull} alt='lock img' className='cashaa logo' /></div>
                    </div>
                  </div>

                  <div className='pddng_15'>
                    <div className='dsp_start mb-4'>
                      <div className='wdth_card_55'>
                        <div className='mb-1'>TVL</div>
                        <span className='secondary_color fnt_wgt_600'>{fnum(Number(e.tvl))} {e.assetName}</span>
                        <div className='d-flex'>
                        <ProgressBar value={(e.tvl / e.tvlcap) * 100} className='wdth_50' showValue={false}></ProgressBar>
                          <div className='prgrs_txt'>{fnum(Number(e.tvlcap))} {e.assetName}</div></div>
                      </div>
                      <div className='mr_card_38'>
                        <div>APR</div>
                        <div className='d-flex'>
                          <div className='holding_val  d-flex whitespace-nowrap'>{(e.averageApy + e.averageLPAPR).toFixed(2)} %
                            <img className={`toolTipPerformance${index} ml_5`} src={infoCircleImg} alt='info' />
                            <Tooltip
                              className='custom-tooltip'
                              target={`.toolTipPerformance${index}`}
                              mouseTrack
                              mouseTrackLeft={10}
                              style={{ backgroundColor: 'var(--body_background)', color: 'white' }}
                            >
                              LP: {(e.averageLPAPR).toFixed(2)}%<br />
                              {e.averageApy !== 0 && `xRIV: ${e.averageApy}%`}
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isAdmin ? <>
                      <div className='dsp mb-4'>
                        <div>Last Harvest <br />
                          <span className='vault_header_font_size'>{e?.lastHarvestdate}</span>
                        </div>
                        <div>
                          Total unharvested rewards <br />
                          <span className='vault_header_font_size'> $0 </span>
                        </div>
                        <div>
                          Harvesting Factor <br />
                          <span className='vault_header_font_size'>0.01%</span>
                        </div>
                      </div>
                      <div className='dsp mb-4'>
                        <div>Current Price<br />
                          <span className='vault_header_font_size'>{e?.currentPrice} {e?.assetName}</span>
                        </div>
                        <div>
                          Current Range <br />
                          <span className='vault_header_font_size'>{e?.tickLowerPrice}-{e?.tickUpperPrice} {e?.assetName} </span>
                        </div>
                        <div>
                          Current Allocation <br />
                          <span className='vault_header_font_size'>{e?.currentAllocation}</span>
                        </div>
                      </div>
                    </> : <></>}
                    <div className='dsp_around mb-2'>
                      <div className='wdth_100'><a className='btn btn-riv-secondary view_btn_wdth' href={`#/vault/${e.identifier}`}>{viewDetailsbuttonVal}</a></div>
                      {isAdmin ? <>
                        <div className='wdth_100 ml_15'><a className='btn btn-riv-secondary view_btn_wdth' href={`#/vaultManager/${e.valutAddress}`}>{managebuttonVal}</a></div>
                      </> : <></>}
                    </div>
                  </div>
                </div>
              </div>
            })}
          </div>
          <div className='second_section outer_section_last last_section_back mb-5'>
            <div className='d-flex align-items-center ml_25'>
              <div className=''>
                <div className='last_header_inner redHatFont'>Asset Manager?</div>
                <div className='last_section_desc'>Provide peace of mind to your investors by offering them self-custody vaults. Build & customize powerful yield farming and structured products. </div>
                <div><a className='btn btn-riv-secondary earlyacesBtn' href={`https://tally.so/r/m6Lope`} target='_blank' rel="noreferrer">Get Early Access</a></div>
              </div>
              <div className=''>
                <img src={assetsManagerImg} alt='assets manager' className='rocketImg wdth_275px' />
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </>}

    </>
  );
}

export default Quant;
